import { api } from './client';

export interface Compra {
  id: number;
  fornecedor_nome?: string | null;
  fornecedor_doc?: string | null;
  chave: string;
  numero: number;
  serie: number;
  valor_total: number;
  status: string;
  data_emissao?: string | null;
  compra_id?: number;
}

export interface CompraItem {
  id: number;
  produto_id?: number | null;
  ordem: number;
  codigo: string;
  descricao: string;
  ncm?: string | null;
  cfop?: string | null;
  ucom?: string | null;
  quantidade: number;
  valor_unitario: number;
  valor_total: number;
}

export interface CompraDetalhe extends Compra {
  itens: CompraItem[];
  resumo: { total_itens: number; vinculados: number; a_vincular: number };
}

export async function listCompras(emitenteId: number, q?: string): Promise<{ data: Compra[] }> {
  const { data } = await api.get('/compras', { params: { emitente_id: emitenteId, q: q || undefined } });
  return data;
}

export async function getCompra(emitenteId: number, compraId: number): Promise<CompraDetalhe> {
  const { data } = await api.get(`/compras/${compraId}`, { params: { emitente_id: emitenteId } });
  return data;
}
